'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: 'اختيار الوقت'
};

exports['default'] = locale;